export const UserServiceFactory = ({ HTTPProfileManager, HTTPSubscription, applicationId, }) => {
    return {
        getUserApps: (userId) => {
            return HTTPSubscription.get(`users/${userId}/apps`).then((result) => result.data);
        },
        getUserProfileById(userId) {
            return HTTPProfileManager.get(`users/${userId}?applicationId=${applicationId}`).then((result) => result.data);
        },
        getCompanyUsersList: (companyId) => {
            return HTTPProfileManager.get(`companies/${companyId}/users`).then((result) => result.data);
        },
        updateCompanyUser: (id, input) => {
            return HTTPProfileManager.put(`users/${id}`, input).then((result) => result.data);
        },
        createCompanyUser: (user) => {
            return HTTPProfileManager.post('users', user).then((result) => result.data);
        },
    };
};
//# sourceMappingURL=user.service.js.map